// localStorage keys
export const LS_KEY_SELECTED_ACCOUNT = 'SELFSERVICE_SELECTED_ACCOUNT';
export const LS_KEY_ACCOUNTS = 'SELFSERVICE_ACCOUNTS';
export const LS_KEY_IMPERSONATION = 'SELFSERVICE_IMPERSONATION';
